// src/services/authApi.js
import apiClient from "./axios";

const authApi = {
  /** POST /api/login/ */
  login: async (identifier, password) => {
    const payload = { identifier, password };
    const response = await apiClient.post("/login/", payload);
    return response.data; // { refresh, access, is_first_login, last_login, ... }
  },

  requestPasswordReset: async (identifier) => {
    const payload = { identifier };
    const response = await apiClient.post("/password-reset/request/", payload);

    if (response.data?.status === 404) {
      const error = new Error(response.data.message || "Email does not exist");
      error.response = response;
      error.isNotFound = true; // <-- custom flag
      throw error;
    }

    return response.data; // usually { "detail": "Password reset email sent." }
  },

  /** POST /api/password_reset/ – with Bearer token */
  resetPassword: async (token, newPassword, confirmPassword) => {
    const payload = {
      new_password: newPassword,
      confirm_password: confirmPassword,
    };

    // Temporarily override headers for this call
    const response = await apiClient.post("/password_reset/", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // usually { "detail": "Password has been reset." }
  },
};

export default authApi;
